import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Form, Input, message, Card, Select, Tooltip, Switch, Button, Modal, ColorPicker } from "antd";
import { useNavigate } from "react-router-dom";
import "dayjs/locale/en";
import dayjs from 'dayjs';
import { AuthContext } from "../../Auth/AuthContext";
import { getSourceByID, updateSource } from "../../utils/API";
const { Option } = Select;

interface EditsourceModalProps {
    visible: boolean;
    taskId?: any;
    onClose: () => any;
    onSuccess: () => any;

}
interface source {
    _id: string;
    name: string;
    category: string;
    isActive: boolean;
}
const EditsourceModal = (props: EditsourceModalProps) => {
    const navigate = useNavigate();
    const { visible, onClose, taskId } = props;
    const { authData } = useContext(AuthContext);
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = React.useState(false);
    const [loading, setLoading] = useState(false);
    const roleId = authData.roleId;


    useEffect(() => {
        const fetchSource = async () => {
            try {
                const response = await getSourceByID(taskId);
                if (!response || !response.source) {
                    message.error("No source data found.");
                    return;
                }

                console.log("API Response:", response); // Debug log

                // Set form values here using the nested source object
                form.setFieldsValue({
                    name: response.source.name,
                    category: response.source.category,
                    color: response.source.color,
                    isActive: response.source.isActive ?? true, // Default to true if undefined
                });
            } catch (error) {
                console.error("Fetch error:", error);
                message.error("Failed to load source data");
            }
        };
        if (visible && taskId) {
            fetchSource();
        } else {
            // Reset form when modal is closed or no taskId
            form.resetFields();
        }
    }, [visible, taskId, form]);

    // Add this to ensure form is reset when modal closes

    const handleUpdate = async (values: any) => {
        setLoading(true);
        try {
            const payload = {
                _id: taskId,
                name: values.name,
                category: values.category,
                color: values.color,
                isActive: values.isActive,
            }

            await updateSource(taskId, payload);

            message.success('source updated successfully!');

            if (props.onSuccess) props.onSuccess();
            if (onClose) onClose();
            // Close the modal
            if (onClose) {
                onClose();
            }

            // Optional: redirect after modal closes
            setTimeout(() => {
                navigate("/source");
            }, 100);

        } catch (error) {
            console.error("Update error:", error);
            if (error instanceof Error) {
                message.error(error.message || "Failed to update source");
            } else {
                message.error("Failed to update source");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            width={600}
            centered={false}
            destroyOnClose
            className="custom-modal"
            bodyStyle={{
                overflowY: "auto",
                fontFamily: "inter, sans-serif",
            }}
            styles={{
                header: {
                    padding: "12px",
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f1f5ffff",
                },
                content: {
                    padding: 0,
                    overflow: "hidden",
                },
            }}
            title={
                <div
                    style={{
                        color: "#4b5563",
                        fontFamily: "inter, sans-serif",
                        fontSize: "20px",
                        fontWeight: 500,
                    }}
                >
                    Edit Source
                </div>
            }
        >
            <Form
                onFinish={handleUpdate}
                form={form}
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 19 }}
                colon={false}
                style={{ margin: 0 }}
            >


                {/* source Name */}
                <div className="elements">

                    <div className="flex justify-center gap-2">
                        {/* Source Name */}
                        <Form.Item
                            label={<span style={{
                                color: '#4b5563',
                                fontFamily: 'inter, sans-serif',
                                fontSize: '14px',
                                paddingLeft: "15px",
                                fontWeight: 500,
                            }}>Source Name <span className="text-red-500">*</span></span>}
                            name="name"
                            required={false}
                            rules={[{ required: true, message: "Please enter Source name" }]}
                        >
                            <Input
                                className="Allinput"
                                placeholder="Source Name"
                                style={{ width: "380px" }}
                            />
                        </Form.Item>
                        <Form.Item

                            required={false}

                            name="color"
                            rules={[{ required: false, message: "Please pick a color" }]}
                            getValueFromEvent={(color) => {
                                return color?.toHexString?.() || "#000000";
                            }}
                            style={{ marginTop: "5px" }}
                        >
                            <ColorPicker
                                format="hex"
                                disabled={false}
                                placement="bottomRight"
                                style={{ marginTop: "0px", position: "relative" }}
                                defaultValue={"#000000"}
                            // showText
                            />
                        </Form.Item>
                    </div>

                    <Form.Item
                        label={<span style={{
                            color: '#4b5563',
                            fontFamily: 'inter, sans-serif',
                            fontSize: '14px',
                            paddingLeft: "15px",
                            fontWeight: 500,
                        }}>Category <span className="text-red-500">*</span></span>}
                        name="category"
                        required={false}
                        rules={[
                            {
                                required: true,
                                message: "Please select a category",
                            },
                        ]}
                    >
                        <Select

                            mode="multiple"
                            size="large"
                            disabled={roleId == 2}
                            className="CustomSelect"
                            placeholder="Select category"
                        >
                            <Select.Option value="JobApplication">JobApplication</Select.Option>
                            <Select.Option value="Sales">Sales</Select.Option>
                            <Select.Option value="Contacts">Contacts</Select.Option>
                        </Select>
                    </Form.Item>

                </div>
                {/* Submit Button */}
                <Col
                    xs={24}
                    sm={24}
                    md={24}
                    xl={24}
                    xxl={20}
                    className="d-flex justify-content-end me-3"
                >
                    <div className="button-wrapper">
                        <button
                            className="allcanclebutton"
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                        <button className="allsubmitebutton" disabled={isLoading}>
                            {isLoading ? "Updating..." : "Update"}
                        </button>
                    </div>
                </Col>


            </Form>

        </Modal>
    );
};


export default EditsourceModal;

